import HeaderComponent from '../../components/shared/Header/HeaderManagerComponent';
import FooterComponent from '../../components/shared/Footer/FooterComponent';
import CookieConsent from '../shared/CookieConsent/CookieConsent';
import dynamic from 'next/dynamic';
const MobileBottomNav = dynamic(() => import('../shared/Mobile/MobileBottomNav'), { ssr: false });

export default function GamesLayout({ children }) {
  return (
    <>
      <HeaderComponent />
      <main>{children}</main>
      <FooterComponent />
      <MobileBottomNav />
      <CookieConsent></CookieConsent>
    </>
  );
}
